export const DEFAULT_MAX_METRICS_COUNT = 4;